import { prepHandleEvent } from "./prepHandleEvent";

export function handleDragOver(event) {
  var myApp = prepHandleEvent(this, true, null, null);
  if (myApp == null) return;
  event.preventDefault();
  event.stopPropagation();
}
